<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">{{$route.query.page}}</span>
      <span class="spacer" />
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="main-container">
      <div class="row margin-b-m" v-if="$route.query.page == 'Professional Development'">
        <div class="col-4">
          <txt label="Name of Institute" name="institute_name" v-model="model.institute_name" />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <txt label="Bill Number" name="bill_number" v-model="model.bill_number" />
        </div>
        <div class="col-4">
          <div class="label">
            <span class="input-label">Bill Date</span>
            <date-picker
              name="bill_date"
              :value="model.bill_date"
              @datevalue="(val)=> model.bill_date = val"
            />
          </div>
        </div>
        <div class="col-4">
          <txt label="Amount" type="number" name="bill_amount" v-model="model.amount" />
        </div>
      </div>
      <div class="row margin-t-m">
        <div class="col-12 margin-t-m">
          <div class="upload-heading">Upload the bill</div>
          <upload @change="(val)=>docUrl=val.data.location" />
        </div>
        <div class="col-12 margin-t-m">
          <btn text="Add Bill" type="secondary" @click="addMore()" />
        </div>
      </div>

      <div class="margin-t-l">
        <data-table
          :columns="tableColumns"
          :tableData="billList"
          :showinrow="true"
          :showhistory="false"
          :showedit="false"
          @delete="deleteItem($event)"
        >
          <template v-slot:rowcontent="slotprops">
            <div>
              <p v-if="slotprops.value.column.key == 'srNo'">{{slotprops.value.index+1}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_number'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'bill_date'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'institute_name' && $route.query.page =='Professional Development'"
              >{{slotprops.value.record['institute_name']}}</p>
              <p
                v-if="slotprops.value.column.key == 'amount'"
              >{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <p
                v-if="slotprops.value.column.key == 'proofs'"
              >{{slotprops.value.record[slotprops.value.column.key].length}} attacment</p>
            </div>
          </template>
        </data-table>
      </div>
    </div>
    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Dependent added succesfully.`"
      btnText="Back"
      @back="back"
    ></pop-up-message>
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      showSuccessMsg: false,
      docUrl: "",
      errmsg: "",
      toast: false,
      model: {
        bill_number: "",
        institute_name: "",
        bill_date: "",
        amount: 0
      },
      dataTableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      profTableColumns: [
        {
          label: "Sr. No.",
          key: "srNo"
        },
        {
          label: "Bill Number",
          key: "bill_number"
        },
        {
          label: "Bill Date",
          key: "bill_date"
        },
        {
          label: "Name of Institute",
          key: "institute_name"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        }
      ],
      billList: [],
      tableColumns: []
    };
  },
  computed: {
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      raData: state => state.RA,
      pdData: state => state.PD,
      fnmData: state => state.FNM,
      beData: state => state.BE
    })
  },
  activated() {
    this.showSuccessMsg = false;
    if (this.$route.query.page == "Professional Development") {
      this.tableColumns = this.profTableColumns;
      this.setPDData();
    } else {
      this.tableColumns = this.dataTableColumns;
      this.setOtherData();
    }
  },
  methods: {
    ...mapActions({
      saveRAData: "dashboard/organisation/utilities/itdeclarations/saveRA",
      savePDData: "dashboard/organisation/utilities/itdeclarations/savePD",
      saveFNMData: "dashboard/organisation/utilities/itdeclarations/saveFNM",
      saveBEData: "dashboard/organisation/utilities/itdeclarations/saveBE"
    }),
    back() {
      this.$router.go(-1);
    },
    async submit() {
      try {
        if (this.$route.query.page == "Professional Development") {
          await this.savePDData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        } else if (this.$route.query.page == "Relocation Allowance") {
          await this.saveRAData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        } else if (
          this.$route.query.page == "Fuel & Maintenance Reimbursement"
        ) {
          await this.saveFNMData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        } else if (this.$route.query.page == "Business Entertainment") {
          await this.saveBEData({
            id: this.$route.query.id,
            data: this.billList,
            proofs: this.billList.map(item => {
              return item.proofs[0];
            })
          });
        }
        this.showSuccessMsg = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setPDData() {
      try {
        if (this.pdData[this.$route.query.id]) {
          this.billList = this.pdData[this.$route.query.id].data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    setOtherData() {
      try {
        if (this.$route.query.page == "Relocation Allowance") {
          if (this.raData[this.$route.query.id]) {
            this.billList = this.raData[this.$route.query.id].data;
          }
        }
        if (this.$route.query.page == "Fuel & Maintenance Reimbursement") {
          if (this.fnmData[this.$route.query.id]) {
            this.billList = this.fnmData[this.$route.query.id].data;
          }
        }
        if (this.$route.query.page == "Business Entertainment") {
          if (this.beData[this.$route.query.id]) {
            this.billList = this.beData[this.$route.query.id].data;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMore() {
      try {
        this.billList.push({
          bill_number: this.model.bill_number,
          bill_date: this.model.bill_date,
          amount: this.model.amount,
          institute_name: this.model.institute_name,
          proofs: [this.docUrl]
        });
        this.resetForm();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    resetForm() {
      try {
        this.model = {
          bill_number: "",
          institute_name: "",
          bill_date: "",
          amount: 0
        };
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteItem(record) {
      try {
        let index = this.billList.findIndex(item => item.name == record.name);
        this.billList.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
.upload-heading {
  font-size: 13px;
  font-weight: 500;
}
</style>
